import https from 'https'

import axios, { AxiosInstance } from 'axios'
import * as rax from 'retry-axios'

export interface Options {
  retryAttempts: number
}

const DEFAULT_OPTIONS: Options = {
  retryAttempts: 0,
}

export class HttpClient {
  protected readonly httpClient: AxiosInstance

  constructor(
    baseUrl: string,
    contentType: string,
    options: Options = DEFAULT_OPTIONS,
  ) {
    this.httpClient = axios.create({
      httpsAgent: new https.Agent({ keepAlive: true }),
      baseURL: baseUrl,
      headers: {
        'Content-Type': contentType,
      },
      raxConfig: {
        retry: options.retryAttempts,
        noResponseRetries: options.retryAttempts,
        backoffType: 'exponential',
        statusCodesToRetry: [
          [100, 199],
          [429, 429],
          [500, 599],
        ],
        onRetryAttempt: (err) => {
          const cfg = rax.getConfig(err)
          console.log(`Retry attempt #${cfg?.currentRetryAttempt}`)
        },
      },
    })
    rax.attach(this.httpClient)
  }

  get get() {
    return this.httpClient.get
  }

  get post() {
    return this.httpClient.post
  }
}
